export function tableFormat(row, column, cellValue) {
  //判断是否为空
  if (cellValue == null || cellValue == undefined) {
    return '--';
  }
  //判断是否数字
  var numReg = /^[+-]?\d*\.?\d*$/;
  var numRe = new RegExp(numReg);
  if (!numRe.test(cellValue)) {
    return cellValue;
  }
  //千分位格式化
  cellValue += '';
  if (!cellValue.includes('.'))
    cellValue += '.';
  return cellValue.replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
    return $1 + ',';
  }).replace(/\.$/, '');
}


// WEBPACK FOOTER //
// ./src/utils/tools.js